// extracted by mini-css-extract-plugin
export default {"table_view":"CouponMastersTableView_table_view__B-u1H","table":"CouponMastersTableView_table__g8NyE","icon":"CouponMastersTableView_icon__Q09ma"};